// Nomes canonicos dos campos exclusivos da planilha
// DISTRIBUICAO DE PROJETOS <ano>.xlsm.
//
// ATUALIZADO para a versao de 48 colunas (A..AV) da planilha. A estrutura
// cresceu de 2 para 4 blocos: INFO PEDIDOS (A-J), ELABORACAO (K-V),
// APROVACAO (W-AI), REVISAO E DETALHAMENTO (AJ-AV).
//
// Apenas colunas EXCLUSIVAS da Distribuicao sao ingeridas. As colunas que
// ela espelha do GERENCIADOR DE PRODUCAO (A, C, D, E, F, G, H, I, J, V, Y, AU)
// NAO entram no parser — vem via join em memoria pela chave NUM. PROJETO
// (ver useAmbientesComJoin em DadosContext).
//
// Convencao de naming: SCREAMING_SNAKE_CASE, prefixo de dominio quando ajuda.

export const D = Object.freeze({
  // Chave de juncao com o GERENCIAL (texto, ex.: "439.13")
  NUMERO_PROJETO: "NUMERO_PROJETO",

  // --- Bloco ELABORACAO (K-V) ---
  SITUACAO_PROJETO: "SITUACAO_PROJETO", // K — "FINALIZADO"/"PAUSADO"/"EM ANDAMENTO"/"PROGRAMADO"/""
  MEDIDOR: "MEDIDOR", // L
  PROJETO_ESPECIAL: "PROJETO_ESPECIAL", // M — "SIM"/"NAO"
  DATA_ENVIO_PROJETAR: "DATA_ENVIO_PROJETAR", // N — inicio da contagem
  PROJETISTA: "PROJETISTA", // O
  CONFIRMACAO_ELETROS: "CONFIRMACAO_ELETROS", // P — "SIM"/"NAO"/"N/A"
  DATA_INICIO_ELABORACAO: "DATA_INICIO_ELABORACAO", // Q
  INTERFERENCIA: "INTERFERENCIA", // R — data em que a interferencia foi detectada
  INTERFERENCIA_RESOLUCAO: "INTERFERENCIA_RESOLUCAO", // S — data de resolucao
  FINALIZACAO_EXECUTIVO: "FINALIZACAO_EXECUTIVO", // T — gatilho de "FINALIZADO"
  FILA_PRIORIDADE: "FILA_PRIORIDADE", // U — numero (dias de atraso vs limite; 0 = no prazo)

  // --- Bloco APROVACAO (W-AI) ---
  VERSAO_PROJETO: "VERSAO_PROJETO", // W — versao automatica (1..5)
  STATUS_PROJETO: "STATUS_PROJETO", // X — "APROVADO"/"REPROVADO"/"EM APROVACAO"/""
  ALTERACAO_1_SOLICITACAO: "ALTERACAO_1_SOLICITACAO", // Z
  ALTERACAO_1_FINALIZACAO: "ALTERACAO_1_FINALIZACAO", // AA
  ALTERACAO_2_SOLICITACAO: "ALTERACAO_2_SOLICITACAO", // AB
  ALTERACAO_2_FINALIZACAO: "ALTERACAO_2_FINALIZACAO", // AC
  ALTERACAO_3_SOLICITACAO: "ALTERACAO_3_SOLICITACAO", // AD
  ALTERACAO_3_FINALIZACAO: "ALTERACAO_3_FINALIZACAO", // AE
  ALTERACAO_4_SOLICITACAO: "ALTERACAO_4_SOLICITACAO", // AF
  ALTERACAO_4_FINALIZACAO: "ALTERACAO_4_FINALIZACAO", // AG
  DATA_APROVACAO_FINAL: "DATA_APROVACAO_FINAL", // AH
  DIAS_ELABORACAO_ATE_APROVACAO: "DIAS_ELABORACAO_ATE_APROVACAO", // AI — numero

  // --- Bloco REVISAO E DETALHAMENTO (AJ-AV) ---
  REVISAO_INICIO: "REVISAO_INICIO", // AJ
  REVISAO_PROJETISTA: "REVISAO_PROJETISTA", // AK
  REVISAO_TERMINO: "REVISAO_TERMINO", // AL
  REVISAO_DATA_LIMITE: "REVISAO_DATA_LIMITE", // AM — AJ + 5 dias uteis
  REVISAO_NECESSARIA: "REVISAO_NECESSARIA", // AN — texto livre
  ENVIO_AO_PPCP: "ENVIO_AO_PPCP", // AO
  DETALHAMENTO_INICIO: "DETALHAMENTO_INICIO", // AP
  DETALHAMENTO_PROJETISTA: "DETALHAMENTO_PROJETISTA", // AQ
  DETALHAMENTO_TERMINO: "DETALHAMENTO_TERMINO", // AR
  DETALHAMENTO_DATA_LIMITE: "DETALHAMENTO_DATA_LIMITE", // AS — AP + 5 dias uteis
  DIFICULDADE_ENCONTRADA: "DIFICULDADE_ENCONTRADA", // AT — texto livre
  VALOR_ERP: "VALOR_ERP", // AV — reservado (integracao PharuERP)
});

// Mapa de letra da coluna na aba "DISTRIBUICAO DE PROJETOS" (versao 48 col).
// Cabecalho na linha 3, dados a partir da linha 4.
// So constam colunas EXCLUSIVAS — as espelhadas do GERENCIAL vem via join.
export const DISTRIBUICAO_COLUMNS = {
  [D.NUMERO_PROJETO]: "B",
  // Elaboracao
  [D.SITUACAO_PROJETO]: "K",
  [D.MEDIDOR]: "L",
  [D.PROJETO_ESPECIAL]: "M",
  [D.DATA_ENVIO_PROJETAR]: "N",
  [D.PROJETISTA]: "O",
  [D.CONFIRMACAO_ELETROS]: "P",
  [D.DATA_INICIO_ELABORACAO]: "Q",
  [D.INTERFERENCIA]: "R",
  [D.INTERFERENCIA_RESOLUCAO]: "S",
  [D.FINALIZACAO_EXECUTIVO]: "T",
  [D.FILA_PRIORIDADE]: "U",
  // Aprovacao
  [D.VERSAO_PROJETO]: "W",
  [D.STATUS_PROJETO]: "X",
  [D.ALTERACAO_1_SOLICITACAO]: "Z",
  [D.ALTERACAO_1_FINALIZACAO]: "AA",
  [D.ALTERACAO_2_SOLICITACAO]: "AB",
  [D.ALTERACAO_2_FINALIZACAO]: "AC",
  [D.ALTERACAO_3_SOLICITACAO]: "AD",
  [D.ALTERACAO_3_FINALIZACAO]: "AE",
  [D.ALTERACAO_4_SOLICITACAO]: "AF",
  [D.ALTERACAO_4_FINALIZACAO]: "AG",
  [D.DATA_APROVACAO_FINAL]: "AH",
  [D.DIAS_ELABORACAO_ATE_APROVACAO]: "AI",
  // Revisao e detalhamento
  [D.REVISAO_INICIO]: "AJ",
  [D.REVISAO_PROJETISTA]: "AK",
  [D.REVISAO_TERMINO]: "AL",
  [D.REVISAO_DATA_LIMITE]: "AM",
  [D.REVISAO_NECESSARIA]: "AN",
  [D.ENVIO_AO_PPCP]: "AO",
  [D.DETALHAMENTO_INICIO]: "AP",
  [D.DETALHAMENTO_PROJETISTA]: "AQ",
  [D.DETALHAMENTO_TERMINO]: "AR",
  [D.DETALHAMENTO_DATA_LIMITE]: "AS",
  [D.DIFICULDADE_ENCONTRADA]: "AT",
  [D.VALOR_ERP]: "AV",
};

export const DISTRIBUICAO_FIELD_TYPES = {
  [D.NUMERO_PROJETO]: "text",
  [D.SITUACAO_PROJETO]: "text",
  [D.MEDIDOR]: "text",
  [D.PROJETO_ESPECIAL]: "text",
  [D.DATA_ENVIO_PROJETAR]: "date",
  [D.PROJETISTA]: "text",
  [D.CONFIRMACAO_ELETROS]: "text",
  [D.DATA_INICIO_ELABORACAO]: "date",
  [D.INTERFERENCIA]: "date",
  [D.INTERFERENCIA_RESOLUCAO]: "date",
  [D.FINALIZACAO_EXECUTIVO]: "date",
  [D.FILA_PRIORIDADE]: "number",
  [D.VERSAO_PROJETO]: "number",
  [D.STATUS_PROJETO]: "text",
  [D.ALTERACAO_1_SOLICITACAO]: "date",
  [D.ALTERACAO_1_FINALIZACAO]: "date",
  [D.ALTERACAO_2_SOLICITACAO]: "date",
  [D.ALTERACAO_2_FINALIZACAO]: "date",
  [D.ALTERACAO_3_SOLICITACAO]: "date",
  [D.ALTERACAO_3_FINALIZACAO]: "date",
  [D.ALTERACAO_4_SOLICITACAO]: "date",
  [D.ALTERACAO_4_FINALIZACAO]: "date",
  [D.DATA_APROVACAO_FINAL]: "date",
  [D.DIAS_ELABORACAO_ATE_APROVACAO]: "number",
  [D.REVISAO_INICIO]: "date",
  [D.REVISAO_PROJETISTA]: "text",
  [D.REVISAO_TERMINO]: "date",
  [D.REVISAO_DATA_LIMITE]: "date",
  [D.REVISAO_NECESSARIA]: "text",
  [D.ENVIO_AO_PPCP]: "date",
  [D.DETALHAMENTO_INICIO]: "date",
  [D.DETALHAMENTO_PROJETISTA]: "text",
  [D.DETALHAMENTO_TERMINO]: "date",
  [D.DETALHAMENTO_DATA_LIMITE]: "date",
  [D.DIFICULDADE_ENCONTRADA]: "text",
  [D.VALOR_ERP]: "number",
};

// Valores na coluna B que sao lancamentos de teste e devem ser descartados.
// Ver MAPEAMENTO_DISTRIBUICAO_DE_PROJETOS.md secao 10.
export const NUMEROS_PROJETO_DE_TESTE = new Set(["0", "1"]);

// Estados calculados pela planilha (lidos como resolvidos). Valores EXATOS
// como saem da planilha (com acentuacao) — usados para comparacao estrita.
export const SITUACAO = Object.freeze({
  FINALIZADO: "FINALIZADO",
  PAUSADO: "PAUSADO",
  EM_ANDAMENTO: "EM ANDAMENTO",
  PROGRAMADO: "PROGRAMADO",
});

export const STATUS = Object.freeze({
  APROVADO: "APROVADO",
  REPROVADO: "REPROVADO",
  EM_APROVACAO: "EM APROVAÇÃO",
  EM_ELABORACAO: "EM ELABORAÇÃO",
});
